import React, { useState, useRef, useEffect, useCallback } from 'react';
import { MONTHS } from './constants';

const MonthSelector = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);

  const selectedDate = value?.[0] instanceof Date ? value[0] : null;
  const selectedMonthIdx = selectedDate ? selectedDate.getMonth() : null;
  const selectedYear = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();

  const handleSelectMonth = useCallback(
    (monthIndex) => {
      const year = selectedYear; // conserva el año del rango actual
      const start = new Date(year, monthIndex, 1);
      const end = new Date(year, monthIndex + 1, 0);
      onChange?.([start, end]);
      setIsOpen(false);
    },
    [onChange, selectedYear],
  );

  // cerrar por click fuera
  useEffect(() => {
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  // cerrar por ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const label = selectedMonthIdx != null ? MONTHS[selectedMonthIdx] : '';

  return (
    <div ref={rootRef} className="relative inline-block w-[225px]">
      <input
        type="text"
        readOnly
        value={label}
        placeholder="Select month"
        onClick={() => setIsOpen((p) => !p)}
        aria-haspopup="listbox"
        className="w-full px-3 py-2 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
      />

      {isOpen && (
        <div
          className="
            absolute top-full left-0 mt-2
            w-[360px] max-w-[90vw]  /* más ancho que el input, similar a la imagen 2 */
            bg-white border border-gray-200 rounded-xl shadow-lg z-50
          "
          role="listbox"
        >
          <div className="px-4 pt-3 text-sm text-gray-500">{selectedYear}</div>
          <div className="grid grid-cols-3 gap-3 p-4">
            {MONTHS.map((name, idx) => {
              const isSelected = selectedMonthIdx === idx;
              return (
                <button
                  key={name}
                  type="button"
                  onClick={() => handleSelectMonth(idx)}
                  className={`text-center px-2 py-2 rounded-md transition-colors duration-150
                    ${isSelected ? 'bg-blue-600 text-white font-semibold' : 'hover:bg-gray-100'}`}
                >
                  {name}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthSelector;
